export const CRM = {
  STATUS: {
    CONTACT_AGAIN: 3,
    SCHEDULED_PRESENTATION: 12,
    PRESENTATION_OFFSET: 13,
    EMAIL_WITH_AN_OFFER: 17,
    SALE_CHANGE_25: 18,
    SALE_CHANGE_50: 19,
    SALE_CHANGE_75: 20,
  },
  BALANCE_SETTLEMENT: {
    INCOME_TYPE_ID: {
      NALEZNOSC: 0,
      WPLATA: 1,
    },
    INCOME_TYPE: {
      0: {
        'title': 'Należność',
        'color': 'danger',
      },
      1: {
        'title': 'Wpłata',
        'color': 'success',
      },
    },
  },
};
export const STATUSES_WITH_CALENDAR = [
  CRM.STATUS.CONTACT_AGAIN,
  CRM.STATUS.SCHEDULED_PRESENTATION,
  CRM.STATUS.PRESENTATION_OFFSET,
  CRM.STATUS.EMAIL_WITH_AN_OFFER,
  CRM.STATUS.SALE_CHANGE_25,
  CRM.STATUS.SALE_CHANGE_50,
  CRM.STATUS.SALE_CHANGE_75,
];

export const GENDER_TYPE_MAN = 2;
export const GENDER_TYPE_WOMAN = 1;

export const FORM_OF_ACCOUNTING_KPIR = 1;
export const FORM_OF_ACCOUNTING_KSIEGI_HANDLOWE = 3;

export const CRM_CRMFORMTYPEID_OSOBA = 1;
export const CRM_CRMFORMTYPEID_FIRMA = 2;

export const TAX_FREE_TYPE_1_12 = 1;
export const TAX_FREE_TYPE_1_24 = 2;
export const TAX_FREE_TYPE_1_36 = 3;

export const CITIZENSHIP_COUNTRY_CODE_PL = 'PL';
export const COUNTRY_CODE_PL = 'PL';
